(function () {
  'use strict';

  // Wait for DOM to be ready
  function init() {
    // Auto-find all images that are NOT already lazy loaded
    const images = document.querySelectorAll('img:not([loading="lazy"])');

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const img = entry.target;
            loadImage(img);
            observer.unobserve(img);
          }
        });
      }, {
        rootMargin: '200px 0px', // Start loading 200px before it enters viewport
        threshold: 0.01
      });

      images.forEach(function (img) {
        // Skip above-the-fold / hero images (first 2 images)
        const allImgs = Array.from(document.querySelectorAll('img'));
        const index = allImgs.indexOf(img);
        if (index < 2) return; // Don't lazy load first 2 images (LCP)

        // If src is already set, back it up and defer loading
        if (img.src && !img.dataset.src) {
          img.dataset.src = img.src;
          img.dataset.srcset = img.srcset || '';
          img.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
          img.srcset = '';
        }

        observer.observe(img);
      });

    } else {
      // Fallback: load all images immediately for old browsers
      images.forEach(function (img) {
        loadImage(img);
      });
    }
  }

  function loadImage(img) {
    if (img.dataset.src) {
      img.src = img.dataset.src;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }
    // If already has src (native fallback), just set loading attribute
    img.setAttribute('loading', 'lazy');
  }

  // Also observe dynamically added images (for AJAX/infinite scroll)
  function observeDynamicImages() {
    const mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            const imgs = node.tagName === 'IMG' ? [node] : node.querySelectorAll('img');
            imgs.forEach(function (img) {
              img.setAttribute('loading', 'lazy');
            });
          }
        });
      });
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      observeDynamicImages();
    });
  } else {
    init();
    observeDynamicImages();
  }

})();